/* Card ADD adds straight to cart when only one variant is in stock; falls back to the quick-add drawer on error. */
(function () {
  if (window.pcardDirectAdd) return;
  window.pcardDirectAdd = true;

  function setLabel(btn, text) {
    btn.textContent = text;
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('.pcard__add[data-direct-variant]');
    if (!btn || btn.dataset.fallback) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;

    var label = btn.textContent;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, 'ADDING…');

    try {
      var cartDrawer = document.querySelector('cart-drawer');
      var sections = 'cart-icon-bubble';
      var drawerSection = cartDrawer && cartDrawer.closest('.shopify-section');
      if (drawerSection) sections += ',' + drawerSection.id.replace('shopify-section-', '');

      var fd = new FormData();
      fd.append('id', btn.dataset.directVariant);
      fd.append('quantity', '1');
      fd.append('sections_url', window.location.pathname);
      fd.append('sections', sections);

      var res = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || res.status);

      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      setLabel(btn, 'ADDED');
      setTimeout(function () {
        btn.classList.remove('is-added');
        setLabel(btn, label);
      }, 1600);

      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        bubble.innerHTML = data.sections['cart-icon-bubble'];
      }
      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(data, false);
      }
      if (typeof window.handleFloCartBtn === 'function') window.handleFloCartBtn();

      var cart = await (await fetch(theme.routes.cart + '.js')).json();
      btn.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { cart: cart, variantId: data.variant_id }
      }));

    } catch (err) {
      setLabel(btn, label);
      btn.dataset.fallback = '1';
      btn.click();
      delete btn.dataset.fallback;
    } finally {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
    }
  }, true);
})();

(function () {
  var el = document.querySelector('[data-ggf-switch]');
  var hour = el ? Number(el.getAttribute('data-ggf-switch')) || 9 : 9;
  var d = new Date(Date.now() + 5.5 * 3600 * 1000);
  if (d.getUTCHours() < hour) d.setUTCDate(d.getUTCDate() - 1);
  var s = document.createElement('style');
  s.textContent = '.pcard__deal[data-ggf-dates~="' + d.toISOString().slice(0, 10) + '"]{display:inline-flex}';
  document.head.appendChild(s);
})();
